module.exports = __webpack_public_path__ + "img/user_manual.d1d4bba2.jpg";